<template>
  <div id="maintenance-screen">
    <div class="message">
      <h2>
        <i18next :translation="$t('common:maintenance.header')">
          <template #cutr>
            <span class="text-amber-600">Cutr</span>
          </template>
        </i18next>
      </h2>
      <p class="whitespace-pre-wrap">{{ $t('common:maintenance.body') }}</p>
      <p>&mdash; {{ $t('common:maintenance.cutrTeam') }}</p>
    </div>
  </div>
</template>

<script></script>

<style scoped>
#maintenance-screen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  background: var(--neutral-50);
  display: flex;
  justify-content: center;
  align-items: center;
}

#maintenance-screen .message {
  max-width: 600px;
  padding: 1em;
}
</style>
